export default __webpack_public_path__ + "static/media/background-parents-evening.cecd15c8.jpg";